module.exports = __webpack_public_path__ + "img/icon-archive.0962c170.svg";